import { Link } from "react-router-dom";
import { C } from "../tokens";
import { SOCIALS, SocialIcon } from "../data/socials";
import { CATEGORIES } from "../data/services";
import { FOUNDED_YEAR, EMAIL, IRA_LICENSE, BRAND } from "../data/company";

const SERVICE_LINKS = CATEGORIES.map(c => [c.name, `/plans/${c.slug}`]);

const NAV_LINKS = [
  ["Home", "/"],
  ["About", "/about"],
  ["Our Team", "/team"],
  ["Testimonials", "/testimonials"],
  ["FAQs", "/faqs"],
  ["Contact", "/contact"],
];

const linkStyle = { display: "block", fontFamily: "'Outfit',sans-serif", fontSize: "13px", marginBottom: "12px", fontWeight: 300, color: C.muted, textDecoration: "none", transition: "color 0.2s" };
const colHead = { fontFamily: "'Outfit',sans-serif", fontSize: "9px", letterSpacing: "3px", textTransform: "uppercase", color: C.goldDeep, marginBottom: "20px", fontWeight: 700 };

function FooterLink({ label, to }) {
  return (
    <Link to={to} style={linkStyle}
      onMouseEnter={e => e.target.style.color = C.crimson} onMouseLeave={e => e.target.style.color = C.muted}
    >{label}</Link>
  );
}

export default function Footer() {
  return (
    <footer data-cursor-color={C.crimson} style={{ background: C.offWhite, color: C.muted, padding: "72px 5vw 32px", borderTop: `1px solid ${C.border}` }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: "64px", marginBottom: "60px", flexWrap: "wrap" }}>
          <div>
            <Link to="/" style={{ display: "inline-block", marginBottom: "20px" }}>
              <img src="/images/lepaz-logo-nav.png" alt={BRAND} height="38" style={{ height: "38px", width: "auto" }}/>
            </Link>
            <p style={{ fontFamily: "'Outfit',sans-serif", fontSize: "13px", lineHeight: 1.85, maxWidth: "320px", fontWeight: 300, marginBottom: "28px", color: C.muted }}>Protection, legacy, and prosperity, built around you. Serving Kenya since {FOUNDED_YEAR}.</p>
            <div style={{ display: "flex", gap: "10px" }}>
              {SOCIALS.map(({ label, url, path }) => (
                <a key={label} href={url} target="_blank" rel="noreferrer" aria-label={label}
                  style={{ width: 38, height: 38, border: `1px solid ${C.border}`, display: "flex", alignItems: "center", justifyContent: "center", color: C.crimson, textDecoration: "none", transition: "all 0.25s" }}
                  onMouseEnter={e => { e.currentTarget.style.background = C.crimson; e.currentTarget.style.color = C.gold; e.currentTarget.style.borderColor = C.crimson; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = C.crimson; e.currentTarget.style.borderColor = C.border; }}
                ><SocialIcon path={path}/></a>
              ))}
            </div>
          </div>
          <div>
            <div style={colHead}>Plans</div>
            {SERVICE_LINKS.map(([l, to]) => <FooterLink key={to} label={l} to={to}/>)}
          </div>
          <div>
            <div style={colHead}>Navigate</div>
            {NAV_LINKS.map(([l, to]) => <FooterLink key={to} label={l} to={to}/>)}
          </div>
        </div>

        {/* Regulatory strip */}
        <div style={{ borderTop: `1px solid ${C.border}`, padding: "20px 0", display: "flex", alignItems: "center", gap: "14px", flexWrap: "wrap" }}>
          <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 30, height: 30, border: `1px solid ${C.gold}66`, color: C.goldDeep, flexShrink: 0 }} aria-hidden="true">
            <svg viewBox="0 0 48 48" width="16" height="16" fill="none"><path d="M24 6L8 12V24C8 33.941 15.163 43.143 24 45C32.837 43.143 40 33.941 40 24V12L24 6Z" stroke="currentColor" strokeWidth="3" strokeLinejoin="round"/></svg>
          </span>
          <span style={{ fontFamily: "'Outfit',sans-serif", fontSize: "12px", fontWeight: 300, color: C.inkMid, letterSpacing: "0.3px" }}>
            Regulated by the Insurance Regulatory Authority (IRA) of Kenya{IRA_LICENSE ? ` · Licence No. ${IRA_LICENSE}` : ""}
          </span>
        </div>

        <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: "28px", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "12px", fontSize: "12px", fontFamily: "'Outfit',sans-serif", fontWeight: 300, color: C.muted }}>
          <span>© {new Date().getFullYear()} {BRAND}. All rights reserved. | Nairobi, Kenya</span>
          <span>{EMAIL}</span>
        </div>
      </div>
      <style>{`@media(max-width:768px){footer>div>div:first-child{grid-template-columns:1fr!important;gap:36px!important}}`}</style>
    </footer>
  );
}
